import React, { useEffect, useState } from "react";
import ConfirmationView from "./components/ConfirmationView";
import Error from "../../../shared/components/Error";
import { withTranslation } from "react-i18next";
import { addToGoogleDataLayer } from "../../../shared/const/utls.js";
import { useSelector } from "react-redux";

const Confirmation = ({ i18n }) => {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "We’ve received your application - HARP- Government of Nova Scotia";
    } else {
      document.title =
        "Nous avons reçu votre demande - Allocation pour services à domicile chez les aînés - Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);

  const addressTypeChange = useSelector((state) => state.app.addressTypeChange);
  useEffect(() => {
    try {
      addToGoogleDataLayer(
        "confirmation",
        "HARP Application",
        i18n.language,
        addressTypeChange
      );
      window.scrollTo(0, 0);
    } catch (e) {
      console.log(e);
    }
  }, [i18n.language, addressTypeChange]);

  return isError ? <Error /> : <ConfirmationView setIsError={setIsError} />;
};

export default withTranslation("common")(Confirmation);
